import { Link } from 'react-router-dom';
import { Mail, MapPin, Phone } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="bg-black text-white py-16" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          <div>
            <h3 className="font-unbounded font-bold text-xl mb-4">AI HOUSE USA</h3>
            <p className="text-gray-400 font-manrope">Live. Learn. Build with AI.</p>
          </div>

          <div>
            <h4 className="font-manrope font-bold mb-4">Quick Links</h4>
            <ul className="space-y-2 text-gray-400">
              <li><Link to="/about" className="hover:text-accent transition-colors">About</Link></li>
              <li><Link to="/program" className="hover:text-accent transition-colors">Program</Link></li>
              <li><Link to="/houses" className="hover:text-accent transition-colors">Houses</Link></li>
              <li><Link to="/curriculum" className="hover:text-accent transition-colors">Curriculum</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-manrope font-bold mb-4">Get Involved</h4>
            <ul className="space-y-2 text-gray-400">
              <li><Link to="/apply" className="hover:text-accent transition-colors">Apply Now</Link></li>
              <li><Link to="/partners" className="hover:text-accent transition-colors">Become a Partner</Link></li>
              <li><Link to="/donate" className="hover:text-accent transition-colors">Donate</Link></li>
              <li><Link to="/contact" className="hover:text-accent transition-colors">Contact Us</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-manrope font-bold mb-4">Contact</h4>
            <ul className="space-y-3 text-gray-400">
              <li className="flex items-center gap-2">
                <Mail size={16} />
                <span>info@thecoffmanagency.com</span>
              </li>
              <li className="flex items-center gap-2">
                <MapPin size={16} />
                <span>Los Angeles, CA</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-gray-800 text-center text-gray-400">
          <p className="font-manrope">&copy; 2025 AI House USA. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};
